module.exports = require('./dist')



//////////////////
// WEBPACK FOOTER
// ./~/styled-theme/index.js
// module id = 31
// module chunks = 0